import {Link} from 'react-router-dom'
import {useDispatch} from 'react-redux'




function MenuItem (props){
  let a = 1;
  const dispatch = useDispatch()

    if (props.title.RecList[0].events[0] === undefined) return <p>Loading....</p>
  
    else{

    return(
        <div className={props.active ? 'menu-table-active' : 'menu-table' }  id="menu-table1" >
        <table className="table" >
          
          <tbody>
              
                
                 
                  
                    
                    
                    {props.title.RecList.map((event) =>{
                      if (props.id == a){
                      return(
                      
                      event.events.map((string) => {
                      if (event.id == a){
                      return(
                       <tr className="table-item" key={string.sid}>
                          <td className="time">{string.timeslot}</td>
                          <td><Link to = '/event' onClick={(e) => dispatch ({type:'TABLE_LOAD_EVENT', payload7: string.sid}) }>{string.title}</Link></td>
                          <td>{string.where}</td>
                       </tr> 

                      )

                     }}))

                    }else{
                      a = a + 1
                    }})}
                    
                    
                    
                    
                    
                   
           

             
          </tbody>
        </table>
      </div>







    );
            }
}




export default MenuItem